const translations = {
  'en-US' :{
    greeting: "Hello",
    welcome: "Welcome",
    welcometoportal: "Welcome to",
    customerportal: "Customer Portal",
    home: "Home",
    systems: "Systems",
    notifications: "Notifications",
    notificationsettings: "Notification Settings",
    editusersettings: "Edit User Settings",
    nonotifications: "No Notifications",
    managecontacts: "Manage Contacts",
    sitemanagement: "Site Management",
    account: "Account",
    settings: "Settings",
    email: "Email",
    emailaddress: "Email Address",
    password: "Password",
    rememberme: "Remember me",
    donthaveanaccount: "Don't have an account?",
    alreadyhaveanaccount: "Already have an account?",
    signup: "Sign Up",
    signin: "Sign In",
    signout: "Sign Out",
    back: "Back",
    done: "Done",
    usernameorpasswordincorrect: "Username or password incorrect. Please try again.",
    passwordincorrect: "Password incorrect. Please try again.",
    forgotpassword: "Forgot Password",
    register: "Register",
    name: "Name",
    phone: "Phone",
    firstname: "First Name",
    lastname: "Last Name",
    timezone: "Time Zone",
    selecttimezone: "Select Time Zone",
    save: "Save",
    saved: "Saved",
    notificationssettingssaved: "Notifications Settings Saved!",
    selectpreferredtimezone: "Select Preferred Time Zone",
    onlyalphabet: "Only alphabetical characters allowed.",
    entervalidphone: "Enter valid phone number.",
    enterregistrationcode: "Please enter the registration code from Fire Rover.",
    registersuccess: "Registered successfully!",
    registerfailed: "Error registering. Please try again.",
    resetpassword: "Reset Password",
    reset: "Reset",
    enternewpassword: "Enter New Password",
    changepassword: "Change Password",
    currentpassword: "Current Password",
    newpassword: "New Password",
    confirmpassword: "Confirm Password",
    validatepassword: "Validate Password",
    passwordsdonotmatch: "Passwords do not match.",
    registrationcode: "Registration Code",
    addregistrationcodes: "Add Registration Codes:",
    registrationcomplete: "Registration complete! You will now be redirected to the sign in page.",
    addcode: "Add Code",
    validatecode: "Validate Code",
    codevalidated: "Code Validated",
    codeverified: "Code Verified!",
    codevalidatefailed: "Invalid code. Please try again.",
    sendcode: "Send Code",
    resendcode: "Resend Code",
    phoneverificationcode: "Phone Verification Code",
    enterverificationcode: "Please enter the verification code sent to your mobile device.",
    enteremailverificationcode: "Please enter the verification code sent to your Email.",
    enteremailforresetcode: "Please enter your email address to recieve a reset code.",
    verificationcodesent: "Verification code sent!",
    checkforverificationcode: "Please check your text messages for the verification code.",
    accountcreatedcheckforcode: "Your account has been created, but you will not recieve notifications until your phone number is verified.",
    verificationcodesentfailure: "Error sending verification code. Please try again.",
    emailisinvalid: "Email is invalid.",
    passwordresetsuccess: "Password reset successfully!",
    passwordresetfailed: "Could not reset password. Please try again.",
    passwordchangefailed: "Could not change password. Please try again.",
    passwordrequirementstxt: "Password must be between 8 and 26 characters long, have at least 1 capital letter, 1 lowercase letter, 1 number, and 1 special character.",
    contacts: "Contacts",
    nocontacts: "No Contacts",
    invitecontactuser: "Invite Contact User",
    personalinformation: "Personal Information",
    inputemail: "Input Email",
    requestpasswordreset: "Request Password Reset",
    search: "Search",
    sitesmanagement: "Sites Management",
    sites: "Sites",
    retrievingsites: "Retrieving Sites",
    retrievingnotifications: "Retrieving Notifications",
    nositesfound: "No Sites Found",
    address: "Address",
    state: "State",
    units: "Units",
    unit: "Unit",
    site: "Site",
    date: "Date",
    systemtime: "System Time",
    localtime: "Local Time",
    confirm: "Confirm",
    cancel: "Cancel",
    close: "Close",
    delete: "Delete",
    promotetomanager: "Promote to Manager",
    promoteusertositemanager: "Promote user to site manager?",
    promoteusertositemanagertip: "Please confirm you are promoting %{name} to a manager for %{site}.",
    demotemanager: "Demote Manager",
    demotemanagertouser: "Demote Manager to User",
    demotesitemanagertouser: "Demote site manager to user?",
    demotesitemanagertousertip: "Please confirm you are demoting %{name} to a user for %{site}.",
    deleteuser: "Delete User",
    removeuser: "Remove User",
    removeuserfromsite: "Remove user from site?",
    removeuserfromsitetip: "Please confirm you are removing %{name} from %{site}.",
    todcontrolinfo: "Time of Day Control Info",
    todcontrolinfotip: "Settings for weekdays and weekends are independent and can be the same or different for both.",
    on247: "On 24/7",
    on247info: "You will receive notifications in real time 24/7.",
    off: "Off",
    offinfo: "You will not receive notifications at any time regardless of Alert and Notification Settings.",
    onperschedule: "On Per Schedule",
    accumulation: "Accumulation",
    accumulationinfo: "Notifications received during off hours will be held and delivered in bulk at the start of the next operational period.",
    startstop: "Start/Stop",
    startstopinfo: "Notifications received during off hours will not be delivered but will be stored in archive.",
    invitesent: "Invite Sent!",
    invitefailed: "Error sending invite. Please try again.",
    inviteuser: "Invite User",
    invitecontactforsite: "Invite Contact for Site",
    sendinvite: "Send Invite",
    testalert: "TEST ALERT",
    testalerts: "Test Alerts",
    fireroveractivated: "Fire Rover Activated",
    accountmanager: "Account Manager",
    accountmanagerphone: "Account Manager Phone",
    centralstation: "Central Station",
    centralstationphone: "Central Station Phone",
    servicedepartmentphone: "Service Department Phone",
    alertsiwanttoreceive: "Alerts I Want to Receive",
    verifiedfire: "Verified Fire - System Prepared for Engagement",
    suppressionactivated: "Suppression Activated",
    mobilesuppressionunit: "Mobile Suppression Unit - Mode Changes",
    alertdeliverymethods: "Alert Delivery Methods",
    fireroverappnotifications: "Firerover App Notifications",
    textnotifications: "Text Notifications",
    pushnotifications: "Push Notifications",
    emailnotifications: "Email Notifications",
    wheniwanttoreceivealerts: "When I Want to Receive Alerts",
    weekdays: "Weekdays",
    weekends: "Weekends",
    starttime: "Start Time",
    endtime: "End Time",
    preferredlanguage: "Preferred Language",
    preferredlanguageNote: "*Impacts notifications only",
    selectpreferredlanguage: "Select Preferred Language",
    selectlanguage: "Select Language",
    smsenabled: "Text Notifications Enabled",
    messageratesmayapply: "Message & data rates may apply.",
    termsofservice: "Terms of Service",
    accept: "Accept",
    english: "English",
    french: "French",
    spanish: "Spanish",
    internalusers: "Internal Users",
    event: "Event",
    showmore: "Show More",
    send: "Send",
    actions: "Actions",
    userdoesnotexist: "User does not exist. Please try again.",
    rowsperpage: "Rows per page",
    noimage: "No Image",

    // Material React Table
    and: 'and',
    changeFilterMode: 'Change filter mode',
    changeSearchMode: 'Change search mode',
    clearFilter: 'Clear filter',
    clearSearch: 'Clear search',
    clearSelection: 'Clear selection',
    clearSort: 'Clear sort',
    clickToCopy: 'Click to copy',
    copy: 'Copy',
    collapse: 'Collapse',
    collapseAll: 'Collapse all',
    columnActions: 'Column Actions',
    copiedToClipboard: 'Copied to clipboard',
    dropToGroupBy: 'Drop to group by {column}',
    edit: 'Edit',
    expand: 'Expand',
    expandAll: 'Expand all',
    filterArrIncludes: 'Includes',
    filterArrIncludesAll: 'Includes all',
    filterArrIncludesSome: 'Includes',
    filterBetween: 'Between',
    filterBetweenInclusive: 'Between Inclusive',
    filterByColumn: 'Filter by {column}',
    filterContains: 'Contains',
    filterEmpty: 'Empty',
    filterEndsWith: 'Ends With',
    filterEquals: 'Equals',
    filterEqualsString: 'Equals',
    filterFuzzy: 'Fuzzy',
    filterGreaterThan: 'Greater Than',
    filterGreaterThanOrEqualTo: 'Greater Than Or Equal To',
    filterInNumberRange: 'Between',
    filterIncludesString: 'Contains',
    filterIncludesStringSensitive: 'Contains',
    filterLessThan: 'Less Than',
    filterLessThanOrEqualTo: 'Less Than Or Equal To',
    filterMode: 'Filter Mode: {filterType}',
    filterNotEmpty: 'Not Empty',
    filterNotEquals: 'Not Equals',
    filterStartsWith: 'Starts With',
    filterWeakEquals: 'Equals',
    filteringByColumn: 'Filtering by {column} - {filterType} {filterValue}',
    goToFirstPage: 'Go to first page',
    goToLastPage: 'Go to last page',
    goToNextPage: 'Go to next page',
    goToPreviousPage: 'Go to previous page',
    grab: 'Grab',
    groupByColumn: 'Group by {column}',
    groupedBy: 'Grouped by ',
    hideAll: 'Hide all',
    hideColumn: 'Hide {column} column',
    max: 'Max',
    min: 'Min',
    move: 'Move',
    noRecordsToDisplay: 'No records to display',
    noResultsFound: 'No results found',
    of: 'of',
    or: 'or',
    pin: 'Pin',
    pinToLeft: 'Pin to left',
    pinToRight: 'Pin to right',
    resetColumnSize: 'Reset column size',
    resetOrder: 'Reset order',
    rowActions: 'Row Actions',
    rowNumber: '#',
    rowNumbers: 'Row Numbers',
    select: 'Select',
    selectedCountOfRowCountRowsSelected: '{selectedCount} of {rowCount} row(s) selected',
    showAll: 'Show all',
    showAllColumns: 'Show all columns',
    showHideColumns: 'Show/Hide columns',
    showHideFilters: 'Show/Hide filters',
    showHideSearch: 'Show/Hide search',
    sortByColumnAsc: 'Sort by {column} ascending',
    sortByColumnDesc: 'Sort by {column} descending',
    sortedByColumnAsc: 'Sorted by {column} ascending',
    sortedByColumnDesc: 'Sorted by {column} descending',
    thenBy: ', then by ',
    toggleDensity: 'Toggle density',
    toggleFullScreen: 'Toggle full screen',
    toggleSelectAll: 'Toggle select all',
    toggleSelectRow: 'Toggle select row',
    toggleVisibility: 'Toggle visibility',
    ungroupByColumn: 'Ungroup by {column}',
    unpin: 'Unpin',
    unpinAll: 'Unpin all'
  },

  'fr-FR' :{
    greeting: "Bonjour",
    welcome: "Bienvenue",
    welcometoportal: "Bienvenue sur le Portail Client",
    customerportal: "Portail du Web ",
    home: "Accueil",
    systems: "Systèmes",
    notifications: "Notifications",
    notificationsettings: "Paramètres de notification",
    editusersettings: "Modifier les paramètres utilisateur",
    nonotifications: "Aucune notification",
    managecontacts: "Gérer les contacts",
    sitemanagement: "Gestion du site",
    account: "Compte",
    settings: "Paramètres",
    email: "Email",
    emailaddress: "Email",
    password: "Mot de passe",
    rememberme: "Se souvenir de moi",
    donthaveanaccount: "Vous n'avez pas de compte?",
    alreadyhaveanaccount: "Vous avez déjà un compte?",
    signup: "S’inscrire",
    signin: "Se connecter",
    signout: "Se déconnecter",
    back: "Retour",
    done: "Terminé",
    usernameorpasswordincorrect: "Nom d'utilisateur ou mot de passe incorrect. Veuillez réessayer.",
    passwordincorrect: "Mot de passe incorrect. Veuillez réessayer.",
    forgotpassword: "Mot de passe oublié",
    register: "S'inscrire",
    name: "Nom",
    phone: "Téléphone",
    firstname: "Prénom",
    lastname: "Nom de famille",
    timezone: "Fuseau horaire",
    selecttimezone: "Sélectionner le fuseau horaire",
    save: "Enregistrer",
    saved: "Enregistré",
    notificationssettingssaved: "Paramètres de notification enregistrés!",
    selectpreferredtimezone: "Sélectionner le fuseau horaire préféré",
    onlyalphabet: "Seuls les caractères alphabétiques sont autorisés.",
    entervalidphone: "Entrez un numéro de téléphone valide.",
    enterregistrationcode: "Veuillez entrer le code d'inscription de Fire Rover.",
    registersuccess: "Inscription réussie !",
    registerfailed: "Erreur lors de l'inscription. Veuillez réessayer.",
    resetpassword: "Réinitialiser le mot de passe",
    reset: "Réinitialiser",
    enternewpassword: "Entrez un nouveau mot de passe",
    changepassword: "Changer le mot de passe",
    currentpassword: "Mot de passe actuel",
    newpassword: "Nouveau mot de passe",
    confirmpassword: "Confirmer le mot de passe",
    validatepassword: "Valider le mot de passe",
    passwordsdonotmatch: "Les mots de passe ne correspondent pas.",
    registrationcode: "Code d'inscription",
    addregistrationcodes: "Ajouter des codes d'inscription:",
    registrationcomplete: "Inscription terminée ! Vous allez maintenant être redirigé vers la page de connexion.",
    addcode: "Ajouter un code",
    validatecode: "Valider le code",
    codevalidated: "Code validé",
    codeverified: "Code vérifié!",
    codevalidatefailed: "Code invalide. Veuillez réessayer.",
    sendcode: "Envoyer le code",
    resendcode: "Renvoyer le code",
    phoneverificationcode: "Code de vérification téléphonique",
    enterverificationcode: "Veuillez entrer le code de vérification envoyé à votre appareil mobile.",
    enteremailverificationcode: "Veuillez entrer le code de vérification envoyé à votre e-mail.",
    enteremailforresetcode: "Veuillez entrer votre adresse e-mail pour recevoir un code de réinitialisation.",
    verificationcodesent: "Code de vérification envoyé!",
    checkforverificationcode: "Veuillez vérifier vos messages texte pour le code de vérification.",
    accountcreatedcheckforcode: "Votre compte a été créé, mais vous ne recevrez pas de notifications tant que votre numéro de téléphone n’aura pas été vérifié.",
    verificationcodesentfailure: "Erreur lors de l’envoi du code de vérification. Veuillez réessayer.",
    emailisinvalid: "L'email est invalide.",
    passwordresetsuccess: "Mot de passe réinitialisé avec succès !",
    passwordresetfailed: "Impossible de réinitialiser le mot de passe. Veuillez réessayer.",
    passwordchangefailed: "Impossible de changer le mot de passe. Veuillez réessayer.",
    passwordrequirementstxt: "Le mot de passe doit contenir entre 8 et 26 caractères, inclure au moins 1 lettre majuscule, 1 lettre minuscule, 1 chiffre et 1 caractère spécial.",
    contacts: "Contacts",
    nocontacts: "Aucun contact",
    invitecontactuser: "Inviter un contact",
    personalinformation: "Informations personnelles",
    inputemail: "Saisir l'email",
    requestpasswordreset: "Demander la réinitialisation du mot de passe",
    search: "Rechercher",
    sitesmanagement: "Gestion des sites",
    sites: "Sites",
    retrievingsites: "Récupération des sites",
    retrievingnotifications: "Récupération des notifications",
    nositesfound: "Aucun site trouvé",
    address: "Adresse",
    state: "État",
    units: "Unités",
    unit: "Unité",
    site: "Site",
    date: "Date",
    systemtime: "Heure du système",
    localtime: "Heure locale",
    confirm: "Confirmer",
    cancel: "Annuler",
    close: "Fermer",
    delete: "Supprimer",
    promotetomanager: "Promouvoir au poste de responsable",
    promoteusertositemanager: "Promouvoir l’utilisateur en gestionnaire de site?",
    promoteusertositemanagertip: "Veuillez confirmer que vous promouvez %{name} au poste de gestionnaire pour %{site}.",
    demotemanager: "Rétrograder le responsable",
    demotemanagertouser: "Rétrograder le responsable en utilisateur",
    demotesitemanagertouser: "Rétrograder le gestionnaire de site en utilisateur?",
    demotesitemanagertousertip: "Veuillez confirmer que vous rétrogradez %{name} au rôle d’utilisateur pour %{site}.",
    deleteuser: "Supprimer l'utilisateur",
    removeuser: "Supprimer l’utilisateur",
    removeuserfromsite: "Supprimer l’utilisateur du site?",
    removeuserfromsitetip: "Veuillez confirmer que vous supprimez %{name} de %{site}.",
    todcontrolinfo: "Informations sur le contrôle horaire",
    todcontrolinfotip: "Les réglages des jours de semaine et des week-ends sont indépendants et peuvent être identiques ou différents.",
    on247: "Actif 24h/24 et 7j/7",
    on247info: "Vous recevrez des notifications en temps réel 24h/24 et 7j/7.",
    off: "Inactif",
    offinfo: "Vous ne recevrez aucune notification, peu importe les paramètres d'alerte.",
    onperschedule: "Actif selon le planning",
    accumulation: "Accumulation",
    accumulationinfo: "Les notifications reçues en dehors des heures d'activité seront regroupées et envoyées au début de la prochaine période opérationnelle.",
    startstop: "Démarrer/Arrêter",
    startstopinfo: "Les notifications reçues en dehors des heures d'activité ne seront pas envoyées mais archivées.",
    invitesent: "Invitation envoyée !",
    invitefailed: "Erreur lors de l'envoi de l'invitation. Veuillez réessayer.",
    inviteuser: "Inviter un utilisateur",
    invitecontactforsite: "Inviter un contact pour le site",
    sendinvite: "Envoyer l'invitation",
    testalert: "ALERTE TEST",
    testalerts: "Alertes test",
    fireroveractivated: "Fire Rover activé",
    accountmanager: "Gestionnaire de compte",
    accountmanagerphone: "Téléphone du gestionnaire de compte",
    centralstation: "Station centrale",
    centralstationphone: "Téléphone de la station centrale",
    servicedepartmentphone: "Téléphone du service technique",
    alertsiwanttoreceive: "Alertes que je souhaite recevoir",
    verifiedfire: "Incendie vérifié - Système prêt à intervenir",
    suppressionactivated: "Extinction activée",
    mobilesuppressionunit: "Unité mobile de suppression - Changement de mode",
    alertdeliverymethods: "Méthodes de livraison des alertes",
    fireroverappnotifications: "Notifications de l'application FireRover",
    textnotifications: "Notifications texte",
    pushnotifications: "Notifications push",
    emailnotifications: "Notifications par email",
    wheniwanttoreceivealerts: "Quand je souhaite recevoir les alertes",
    weekdays: "Jours de semaine",
    weekends: "Week-ends",
    starttime: "Heure de début",
    endtime: "Heure de fin",
    preferredlanguage: "Langue préférée",
    preferredlanguageNote: "*Affecte uniquement les notifications",
    selectpreferredlanguage: "Sélectionner la langue préférée",
    selectlanguage: "Sélectionner la langue",
    smsenabled: "Notifications texte activés",
    messageratesmayapply: "Des frais de messagerie peuvent s'appliquer. Les SMS peuvent ne pas être disponibles dans votre pays.",
    termsofservice: "Conditions d'utilisation",
    accept: "Accepter",
    english: "Anglais",
    french: "Français",
    spanish: "Espagnol",
    internalusers: "Utilisateurs internes",
    event: "Événement",
    showmore: "Afficher plus",
    send: "Envoyer",
    actions: "Actions",
    userdoesnotexist: "L’utilisateur n’existe pas. Veuillez réessayer.",
    rowsperpage: "Lignes par page",
    noimage: "Aucune Image",

    // Material React Table
    and: 'et',
    changeFilterMode: 'Changer le mode de filtre',
    changeSearchMode: 'Changer le mode de recherche',
    clearFilter: 'Effacer le filtre',
    clearSearch: 'Effacer la recherche',
    clearSelection: 'Effacer la sélection',
    clearSort: 'Effacer le tri',
    clickToCopy: 'Cliquer pour copier',
    copy: 'Copier',
    collapse: 'Réduire',
    collapseAll: 'Tout réduire',
    columnActions: 'Actions de colonne',
    copiedToClipboard: 'Copié dans le presse-papiers',
    dropToGroupBy: 'Déposer pour grouper par {column}',
    edit: 'Modifier',
    expand: 'Développer',
    expandAll: 'Tout développer',
    filterArrIncludes: 'Inclut',
    filterArrIncludesAll: 'Inclut tout',
    filterArrIncludesSome: 'Inclut',
    filterBetween: 'Entre',
    filterBetweenInclusive: 'Entre (inclusif)',
    filterByColumn: 'Filtrer par {column}',
    filterContains: 'Contient',
    filterEmpty: 'Vide',
    filterEndsWith: 'Se termine par',
    filterEquals: 'Égal à',
    filterEqualsString: 'Égal à',
    filterFuzzy: 'Approximatif',
    filterGreaterThan: 'Supérieur à',
    filterGreaterThanOrEqualTo: 'Supérieur ou égal à',
    filterInNumberRange: 'Entre',
    filterIncludesString: 'Contient',
    filterIncludesStringSensitive: 'Contient',
    filterLessThan: 'Inférieur à',
    filterLessThanOrEqualTo: 'Inférieur ou égal à',
    filterMode: 'Mode de filtre : {filterType}',
    filterNotEmpty: 'Non vide',
    filterNotEquals: 'Différent de',
    filterStartsWith: 'Commence par',
    filterWeakEquals: 'Égal à',
    filteringByColumn: 'Filtrage par {column} - {filterType} {filterValue}',
    goToFirstPage: 'Aller à la première page',
    goToLastPage: 'Aller à la dernière page',
    goToNextPage: 'Aller à la page suivante',
    goToPreviousPage: 'Aller à la page précédente',
    grab: 'Saisir',
    groupByColumn: 'Grouper par {column}',
    groupedBy: 'Groupé par ',
    hideAll: 'Tout masquer',
    hideColumn: 'Masquer la colonne {column}',
    max: 'Max',
    min: 'Min',
    move: 'Déplacer',
    noRecordsToDisplay: 'Aucun enregistrement à afficher',
    noResultsFound: 'Aucun résultat trouvé',
    of: 'sur',
    or: 'ou',
    pin: 'Épingler',
    pinToLeft: 'Épingler à gauche',
    pinToRight: 'Épingler à droite',
    resetColumnSize: 'Réinitialiser la taille de colonne',
    resetOrder: 'Réinitialiser l\'ordre',
    rowActions: 'Actions de ligne',
    rowNumber: '#',
    rowNumbers: 'Numéros de ligne',
    select: 'Sélectionner',
    selectedCountOfRowCountRowsSelected: '{selectedCount} sur {rowCount} ligne(s) sélectionnée(s)',
    showAll: 'Tout afficher',
    showAllColumns: 'Afficher toutes les colonnes',
    showHideColumns: 'Afficher/Masquer les colonnes',
    showHideFilters: 'Afficher/Masquer les filtres',
    showHideSearch: 'Afficher/Masquer la recherche',
    sortByColumnAsc: 'Trier par {column} croissant',
    sortByColumnDesc: 'Trier par {column} décroissant',
    sortedByColumnAsc: 'Trié par {column} croissant',
    sortedByColumnDesc: 'Trié par {column} décroissant',
    thenBy: ', puis par ',
    toggleDensity: 'Basculer la densité',
    toggleFullScreen: 'Basculer en plein écran',
    toggleSelectAll: 'Basculer tout sélectionner',
    toggleSelectRow: 'Basculer sélection ligne',
    toggleVisibility: 'Basculer la visibilité',
    ungroupByColumn: 'Dégrouper par {column}',
    unpin: 'Désépingler',
    unpinAll: 'Tout désépingler'
  },

  'es-ES' :{
    greeting: "Hola",
    welcome: "Bienvenido",
    welcometoportal: "Bienvenido al Portal de Clientes de",
    customerportal: "Portal del Web de",
    home: "Inicio",
    systems: "Sistemas",
    notifications: "Notificaciones",
    notificationsettings: "Configuración de notificaciones",
    editusersettings: "Editar configuración de usuario",
    nonotifications: "Sin notificaciones",
    managecontacts: "Gestionar contactos",
    sitemanagement: "Gestión del sitio",
    account: "Cuenta",
    settings: "Configuraciones",
    email: "Correo electrónico",
    emailaddress: "Correo electrónico",
    password: "Contraseña",
    rememberme: "Recuérdame",
    donthaveanaccount: "¿No tienes una cuenta?",
    alreadyhaveanaccount: "¿Ya tienes una cuenta?",
    signup: "Registrarse",
    signin: "Iniciar sesión",
    signout: "Cerrar sesión",
    back: "Atrás",
    done: "Hecho",
    usernameorpasswordincorrect: "Nombre de usuario o contraseña incorrectos. Inténtalo de nuevo.",
    passwordincorrect: "Contraseña incorrecta. Inténtalo de nuevo.",
    forgotpassword: "¿Olvidaste tu contraseña?",
    register: "Registrarse",
    name: "Nombre",
    phone: "Teléfono",
    firstname: "Nombre",
    lastname: "Apellido",
    timezone: "Zona horaria",
    selecttimezone: "Seleccionar zona horaria",
    save: "Guardar",
    saved: "Guardado",
    notificationssettingssaved: "¡Configuración de notificaciones guardada!",
    selectpreferredtimezone: "Seleccionar zona horaria preferida",
    onlyalphabet: "Solo se permiten caracteres alfabéticos.",
    entervalidphone: "Ingrese un número de teléfono válido.",
    enterregistrationcode: "Por favor, ingrese el código de registro de Fire Rover.",
    enteremailforresetcode: "Por favor, ingresa tu dirección de correo electrónico para recibir un código de restablecimiento.",
    registersuccess: "¡Registrado exitosamente!",
    registerfailed: "Error al registrar. Inténtalo de nuevo.",
    resetpassword: "Restablecer contraseña",
    reset: "Restablecer",
    enternewpassword: "Ingrese nueva contraseña",
    changepassword: "Cambiar contraseña",
    currentpassword: "Contraseña actual",
    newpassword: "Nueva contraseña",
    confirmpassword: "Confirmar contraseña",
    validatepassword: "Validar contraseña",
    passwordsdonotmatch: "Las contraseñas no coinciden.",
    registrationcode: "Código de registro",
    addregistrationcodes: "Agregar códigos de registro:",
    registrationcomplete: "¡Registro completo! Ahora serás redirigido a la página de inicio de sesión.",
    addcode: "Agregar código",
    validatecode: "Validar código",
    codevalidated: "Código validado",
    codeverified: "¡Código verificado!",
    codevalidatefailed: "Código inválido. Inténtalo de nuevo.",
    sendcode: "Enviar código",
    resendcode: "Reenviar código",
    phoneverificationcode: "Código de verificación telefónica",
    enterverificationcode: "Por favor, ingresa el código de verificación enviado a tu dispositivo móvil.",
    enteremailverificationcode: "Por favor, ingresa el código de verificación enviado a tu correo electrónico.",
    verificationcodesent: "¡Código de verificación enviado!",
    checkforverificationcode: "Por favor, revisa tus mensajes de texto para encontrar el código de verificación.",
    accountcreatedcheckforcode: "Tu cuenta ha sido creada, pero no recibirás notificaciones hasta que tu número de teléfono esté verificado.",
    verificationcodesentfailure: "Error al enviar el código de verificación. Por favor, inténtalo de nuevo.",
    emailisinvalid: "El correo electrónico no es válido.",
    passwordresetsuccess: "¡Contraseña restablecida con éxito!",
    passwordresetfailed: "No se pudo restablecer la contraseña. Inténtalo de nuevo.",
    passwordchangefailed: "No se pudo cambiar la contraseña. Inténtalo de nuevo.",
    passwordrequirementstxt: "La contraseña debe tener entre 8 y 26 caracteres, incluir al menos 1 letra mayúscula, 1 letra minúscula, 1 número y 1 carácter especial.",
    contacts: "Contactos",
    nocontacts: "Sin contactos",
    invitecontactuser: "Invitar contacto",
    personalinformation: "Información personal",
    inputemail: "Ingresar correo electrónico",
    requestpasswordreset: "Solicitar restablecimiento de contraseña",
    search: "Buscar",
    sitesmanagement: "Gestión de sitios",
    sites: "Sitios",
    retrievingsites: "Recuperando sitios",
    retrievingnotifications: "Recuperando Notificaciones",
    nositesfound: "No se encontraron sitios",
    address: "Dirección",
    state: "Estado",
    units: "Unidades",
    unit: "Unidad",
    site: "Sitio",
    date: "Fecha",
    systemtime: "Hora del sistema",
    localtime: "Hora local",
    confirm: "Confirmar",
    cancel: "Cancelar",
    close: "Cerrar",
    delete: "Eliminar",
    promotetomanager: "Promover a administrador",
    promoteusertositemanager: "¿Promover al usuario a administrador del sitio?",
    promoteusertositemanagertip: "Por favor, confirma que estás promoviendo a %{name} como administrador de %{site}.",
    demotemanager: "Degradar administrador",
    demotemanagertouser: "Degradar administrador a usuario",
    demotesitemanagertouser: "¿Degradar al administrador del sitio a usuario?",
    demotesitemanagertousertip: "Por favor, confirma que estás degradando a %{name} al rol de usuario para %{site}.",
    deleteuser: "Eliminar usuario",
    removeuser: "Eliminar usuario",
    removeuserfromsite: "¿Eliminar al usuario del sitio?",
    removeuserfromsitetip: "Por favor, confirma que estás eliminando a %{name} de %{site}.",
    todcontrolinfo: "Información de control por hora del día",
    todcontrolinfotip: "Las configuraciones para días de semana y fines de semana son independientes y pueden ser iguales o diferentes.",
    on247: "Activado 24/7",
    on247info: "Recibirá notificaciones en tiempo real las 24 horas, todos los días.",
    off: "Desactivado",
    offinfo: "No recibirá notificaciones en ningún momento, sin importar la configuración de alertas.",
    onperschedule: "Activado según horario",
    accumulation: "Acumulación",
    accumulationinfo: "Las notificaciones recibidas fuera del horario se agruparán y entregarán al comienzo del siguiente periodo operativo.",
    startstop: "Iniciar/Detener",
    startstopinfo: "Las notificaciones recibidas fuera del horario no se entregarán pero se archivarán.",
    invitesent: "¡Invitación enviada!",
    invitefailed: "Error al enviar la invitación. Inténtalo de nuevo.",
    inviteuser: "Invitar a un usuario",
    invitecontactforsite: "Invitar contacto para el sitio",
    sendinvite: "Enviar invitación",
    testalert: "ALERTA DE PRUEBA",
    testalerts: "Alertas de prueba",
    fireroveractivated: "Fire Rover activado",
    accountmanager: "Administrador de cuenta",
    accountmanagerphone: "Teléfono del administrador de cuenta",
    centralstation: "Estación central",
    centralstationphone: "Teléfono de la estación central",
    servicedepartmentphone: "Teléfono del departamento de servicio",
    alertsiwanttoreceive: "Alertas que quiero recibir",
    verifiedfire: "Incendio verificado - Sistema preparado para intervención",
    suppressionactivated: "Supresión activada",
    mobilesuppressionunit: "Unidad móvil de supresión - Cambios de modo",
    alertdeliverymethods: "Métodos de entrega de alertas",
    fireroverappnotifications: "Notificaciones de la app FireRover",
    textnotifications: "Notificaciones de texto",
    pushnotifications: "Notificaciones push",
    emailnotifications: "Notificaciones por correo electrónico",
    wheniwanttoreceivealerts: "Cuándo quiero recibir alertas",
    weekdays: "Días de semana",
    weekends: "Fines de semana",
    starttime: "Hora de inicio",
    endtime: "Hora de finalización",
    preferredlanguage: "Idioma preferido",
    preferredlanguageNote: "*Afecta solo las notificaciones",
    selectpreferredlanguage: "Seleccionar idioma preferido",
    selectlanguage: "Seleccionar idioma",
    smsenabled: "Notificaciones de texto activado",
    messageratesmayapply: "Pueden aplicarse tarifas de mensajes y datos. Los SMS pueden no estar disponibles en su país.",
    termsofservice: "Términos del servicio",
    accept: "Aceptar",
    english: "Inglés",
    french: "Francés",
    spanish: "Español",
    internalusers: "Usuarios internos",
    event: "Evento",
    showmore: "Mostrar más",
    send: "Enviar",
    actions: "Acciones",
    userdoesnotexist: "El usuario no existe. Por favor, inténtalo de nuevo.",
    rowsperpage: "Filas por página",
    noimage: "Sin Imagen",

    // Material React Table
    and: 'y',
    changeFilterMode: 'Cambiar modo de filtro',
    changeSearchMode: 'Cambiar modo de búsqueda',
    clearFilter: 'Limpiar filtro',
    clearSearch: 'Limpiar búsqueda',
    clearSelection: 'Limpiar selección',
    clearSort: 'Limpiar orden',
    clickToCopy: 'Clic para copiar',
    copy: 'Copiar',
    collapse: 'Contraer',
    collapseAll: 'Contraer todo',
    columnActions: 'Acciones de columna',
    copiedToClipboard: 'Copiado al portapapeles',
    dropToGroupBy: 'Soltar para agrupar por {column}',
    edit: 'Editar',
    expand: 'Expandir',
    expandAll: 'Expandir todo',
    filterArrIncludes: 'Incluye',
    filterArrIncludesAll: 'Incluye todo',
    filterArrIncludesSome: 'Incluye',
    filterBetween: 'Entre',
    filterBetweenInclusive: 'Entre (inclusivo)',
    filterByColumn: 'Filtrar por {column}',
    filterContains: 'Contiene',
    filterEmpty: 'Vacío',
    filterEndsWith: 'Termina con',
    filterEquals: 'Igual a',
    filterEqualsString: 'Igual a',
    filterFuzzy: 'Aproximado',
    filterGreaterThan: 'Mayor que',
    filterGreaterThanOrEqualTo: 'Mayor o igual a',
    filterInNumberRange: 'Entre',
    filterIncludesString: 'Contiene',
    filterIncludesStringSensitive: 'Contiene',
    filterLessThan: 'Menor que',
    filterLessThanOrEqualTo: 'Menor o igual a',
    filterMode: 'Modo de filtro: {filterType}',
    filterNotEmpty: 'No vacío',
    filterNotEquals: 'Diferente de',
    filterStartsWith: 'Comienza con',
    filterWeakEquals: 'Igual a',
    filteringByColumn: 'Filtrando por {column} - {filterType} {filterValue}',
    goToFirstPage: 'Ir a la primera página',
    goToLastPage: 'Ir a la última página',
    goToNextPage: 'Ir a la página siguiente',
    goToPreviousPage: 'Ir a la página anterior',
    grab: 'Agarrar',
    groupByColumn: 'Agrupar por {column}',
    groupedBy: 'Agrupado por ',
    hideAll: 'Ocultar todo',
    hideColumn: 'Ocultar columna {column}',
    max: 'Máx',
    min: 'Mín',
    move: 'Mover',
    noRecordsToDisplay: 'No hay registros para mostrar',
    noResultsFound: 'No se encontraron resultados',
    of: 'de',
    or: 'o',
    pin: 'Fijar',
    pinToLeft: 'Fijar a la izquierda',
    pinToRight: 'Fijar a la derecha',
    resetColumnSize: 'Restablecer tamaño de columna',
    resetOrder: 'Restablecer orden',
    rowActions: 'Acciones de fila',
    rowNumber: '#',
    rowNumbers: 'Números de fila',
    select: 'Seleccionar',
    selectedCountOfRowCountRowsSelected: '{selectedCount} de {rowCount} fila(s) seleccionada(s)',
    showAll: 'Mostrar todo',
    showAllColumns: 'Mostrar todas las columnas',
    showHideColumns: 'Mostrar/Ocultar columnas',
    showHideFilters: 'Mostrar/Ocultar filtros',
    showHideSearch: 'Mostrar/Ocultar búsqueda',
    sortByColumnAsc: 'Ordenar por {column} ascendente',
    sortByColumnDesc: 'Ordenar por {column} descendente',
    sortedByColumnAsc: 'Ordenado por {column} ascendente',
    sortedByColumnDesc: 'Ordenado por {column} descendente',
    thenBy: ', luego por ',
    toggleDensity: 'Alternar densidad',
    toggleFullScreen: 'Alternar pantalla completa',
    toggleSelectAll: 'Alternar seleccionar todo',
    toggleSelectRow: 'Alternar selección fila',
    toggleVisibility: 'Alternar visibilidad',
    ungroupByColumn: 'Desagrupar por {column}',
    unpin: 'Desfijar',
    unpinAll: 'Desfijar todo'
  }  
}
export { translations };